module.exports = Aicons;